// extracted by mini-css-extract-plugin
export default {"collapseContainer":"CollapseCardV2_collapseContainer__naxug","groupName":"CollapseCardV2_groupName__vgT2I"};